<template>
  <div class="main">
    <c-panel title="Coleções e séries" titleIcon="fas fa-layer-group">
      <!--
        Item 2: "cadastro de coleções e séries dos exemplares, permitindo informar a
        descrição, quantidade de volumes e o tipo, com as opções coleção ou série".
      -->
      <catalogo-crud tipo="colecao" rotuloNovo="NOVA COLEÇÃO" nomeSingular="registro"
                     placeholderBusca="Pesquisar por descrição"
                     :campos="campos" :colunas="colunas" :filtroExtra="filtroExtra"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

const TIPOS = [{ valor: 'colecao', rotulo: 'Coleção' }, { valor: 'serie', rotulo: 'Série' }]

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'descricao', label: 'Descrição', obrigatorio: true, span: 24, max: 191 },
      { chave: 'tipo', label: 'Tipo', tipo: 'select', obrigatorio: true, opcoes: TIPOS, span: 12 },
      { chave: 'quantidade_volumes', label: 'Quantidade de volumes', tipo: 'numero', span: 12 }
    ],
    colunas: [
      { chave: 'descricao', label: 'Descrição' },
      { chave: 'tipo', label: 'Tipo', largura: '110px', mapa: { colecao: 'Coleção', serie: 'Série' } },
      { chave: 'quantidade_volumes', label: 'Volumes', largura: '100px', mobileOculto: true }
    ],
    filtroExtra: { chave: 'tipo_colecao', label: 'Tipo', opcoes: TIPOS }
  })
}
</script>
